import React from 'react';
import { clsx, createUseStyles, divide, negative } from '@pushpay/styles';
import { useResponsiveProp } from '@pushpay/theming';
const useStyles = createUseStyles(theme => ({
  root: ({
    space
  }) => ({
    width: '100%',
    '&:before': {
      content: '""',
      display: 'block',
      marginTop: negative(theme.SPACING[space])
    }
  }),
  wrapper: ({
    space
  }) => ({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginLeft: negative(theme.SPACING[space])
  }),
  tile: ({
    columns,
    space
  }) => {
    const width = divide('100%', columns);
    return {
      maxWidth: width,
      flexBasis: width,
      padding: `${theme.SPACING[space]} 0 0 ${theme.SPACING[space]}`
    };
  }
}));
export const Tiles = ({
  classes: classesProp,
  className: classNameProp,
  columns: columnsProp = 4,
  space: spaceProp = 'MEDIUM',
  children,
  ...rest
}) => {
  const columns = useResponsiveProp(columnsProp);
  const space = useResponsiveProp(spaceProp);
  const classes = useStyles(classesProp, {
    columns,
    space
  });
  const className = clsx(classNameProp, classes.root);
  const tiles = React.Children.map(children, child => {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.tile
    }, child);
  });
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: className
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, tiles));
};